import type { LucideIcon } from 'lucide-react';
import {
  AssigneeIcon,
  CriticalPriorityIcon,
  OverdueIcon,
  PendingIcon,
  TicketIcon,
  UncategorizedIcon,
} from '@/shared/config';

export const SET_KEYS = [
  'tab',
  'who',
  'status',
  'priority',
  'groupId',
  'mass',
  'sla',
  'myclients',
  'cat',
  'svc',
  'sort',
  'q',
] as const;

const STOCK_KEYS = SET_KEYS.filter((k) => k !== 'tab');

export const STATUS_OPEN = 'open';

export const PRESET_META: Record<string, { Icon: LucideIcon; hint: string }> = {
  new: { Icon: TicketIcon, hint: 'Без исполнителя, не закрытые — их нужно разобрать' },
  mine: { Icon: AssigneeIcon, hint: 'Где вы исполнитель или участник, не закрытые' },
  burning: { Icon: CriticalPriorityIcon, hint: 'Срок SLA вот-вот выйдет' },
  breached: { Icon: OverdueIcon, hint: 'Срок SLA уже вышел, заявка не закрыта' },
  waiting: { Icon: PendingIcon, hint: 'Требуют уточнения — мяч на стороне заявителя' },
  unclassified: { Icon: UncategorizedIcon, hint: 'Открытые заявки со свободной темой — переклассифицировать' },
};

export function snapshotOf(params: URLSearchParams): Record<string, string> {
  const out: Record<string, string> = {};
  for (const key of SET_KEYS) {
    const v = params.get(key);
    if (v) out[key] = v;
  }
  return out;
}

export function withoutTab(snapshot: Record<string, string>): Record<string, string> {
  const { tab: _tab, ...rest } = snapshot;
  return rest;
}

export function matchesPreset(query: Record<string, string>, current: Record<string, string>): boolean {
  return STOCK_KEYS.every((key) => (query[key] ?? '') === (current[key] ?? ''));
}

export function presetPatch(query: Record<string, string>): Record<string, string> {
  return Object.fromEntries(STOCK_KEYS.map((key) => [key, query[key] ?? '']));
}

export function clearPatch(): Record<string, string> {
  return Object.fromEntries(STOCK_KEYS.map((key) => [key, '']));
}

export function revealSelected(viewport: HTMLElement | null): void {
  const el = viewport?.querySelector<HTMLElement>('[aria-selected="true"], [aria-pressed="true"]');
  if (!viewport || !el) return;
  const v = viewport.getBoundingClientRect();
  const r = el.getBoundingClientRect();
  if (r.left >= v.left && r.right <= v.right) return;
  viewport.scrollLeft += r.left - v.left - (v.width - r.width) / 2;
}
